import { GrupoAcesso } from "../../models/grupo_acesso";
import { IGetGrupoAcessoUseCase } from "../../../presentation/useCases/read/get_grupo_acesso_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * GetGrupoAcessoUseCase
 */

export class GetGrupoAcessoUseCase implements IGetGrupoAcessoUseCase {
  constructor(
    private readonly repository: IAdministracaoRepository,
  ) { }

  async getGrupoAcesso(
    idGrupoAcesso: number,
  ): Promise<GrupoAcesso> {
    const response = await this.repository.getGrupoAcesso(idGrupoAcesso);
    return response;
  }
}